###
# editedFilterSet       (object)     FilterSet object for cloning
# structure             (object)     StructureCache.getStructure() responce
# filterSets            (object)     FilterSets.get(clientId) responce
# readyToSave           (boolean)    activate/deactivate of "Clone"
#                                      buttons in parent directive
###
angular.module('rjmNg.directives').directive "filterSetCloner", [
  () ->
    restrict: "E"
    templateUrl: "directive.filterSetCloner.html"
    replace: false
    controllerAs: 'view'
    scope: {
      editedFilterSet: '=?'
      structure: '='
      filterSets: '='
      readyToSave: '='
    }
    bindToController: true
    controller: [
      "$routeParams"
      "$scope"
      "FilterSets"
      "notification"
      "errorConstants"
      "dataTypeNames"
      "logger"
      (
        $routeParams
        $scope
        FilterSets
        notification
        errorConstants
        dataTypeNames
        logger
      ) ->

        view = @
        view.showColumnMatcher = false
        view.clientId = $routeParams.clientId
        view.columns = []
        view.filterSetsNames = []

        view.columnsForCloning = []
        view.notificationTemplate = 'template.notification.html'
        notificationTimeout = 15

        view.selectedTable =
          table: null
          column: null

        STATUS =
          MATCH: "Match"
          ERROR: "Error"
          NOSET: "No Set"

        view.readyToSave = false

        _getColumnsForCloning = () ->
          ids = []
          for filter in view.editedFilterSet.filters
            if !(filter.left.column_id in ids)
              ids.push(filter.left.column_id)
          # Array of filter set columns for matching when cloning
          view.columnsForCloning = []
          for id in ids
            sourceColumn =
              id: id
              name: view.structure.columns[id].name
              is_primary_key: view.structure.columns[id].is_primary_key
              field_type: view.structure.columns[id].field_type
              currency_code: view.structure.columns[id].currency_code
              data_type: type: view.structure.columns[id].data_type.type
              # additional
              status: STATUS.NOSET
              message: false
              table: null
              column: null
            view.columnsForCloning.push(sourceColumn)

        _updateColumnsForCloning = () ->
          for sourceColumn in view.columnsForCloning
            sourceColumn.table = view.selectedTable.table
            sourceColumn.column = null
            sourceColumn.status = STATUS.NOSET
            sourceColumn.message = false
            for column in view.columns
              if column.table_id is view.selectedTable.table and
                column.name is sourceColumn.name and
                column.data_type.type is sourceColumn.data_type.type
                  sourceColumn.column = column.id
                  sourceColumn.status = STATUS.MATCH

        _tableCanBeUsed = () ->
          # a table can be used if columns data types corresponds the columns data types of the source filter set
          sourceDataTypes = []
          for sourceColumn in view.columnsForCloning
            sourceDataTypes.push(sourceColumn.data_type.type)

          tableDataTypes = []
          for column in view.columns
            if column.table_id is view.selectedTable.table and !(column.data_type.type in tableDataTypes)
              tableDataTypes.push(column.data_type.type)

          return _.every(sourceDataTypes, (dataType) -> dataType in tableDataTypes)

        _isValid = () ->
          valid = true
          # validate name and selected table
          if view.filterSetName is "" or view.selectedTable.table is null
            valid = false
          # validate columns for cloning
          for sourceColumn in view.columnsForCloning
            if sourceColumn.column is null
              valid = false
            else
              if sourceColumn.data_type.type is view.getColumnDataType(sourceColumn.column)
                sourceColumn.status = STATUS.MATCH
                sourceColumn.message = false
              else
                valid = false
                typeL = dataTypeNames[sourceColumn.data_type.type]
                typeR = dataTypeNames[view.getColumnDataType(sourceColumn.column)]
                sourceColumn.status = STATUS.ERROR
                sourceColumn.message = "Data type doesn't match: '#{typeR}' instead of '#{typeL}'."
          return valid

        _isFilterSetNameValid = () ->
          if view.filterSetName in view.filterSetsNames
            _showWarning("A Filter Set with this name already exists. Please try another name.")
            return false
          else
            return true

        _showWarning = (text) ->
          notification.warning("warning", text, "filterSetCloner", null, notificationTimeout)

        _showError = (text) ->
          notification.error("Server Error", text, "filterSetCloner", null, notificationTimeout)

        view.isMatch = (status) ->
          return status is STATUS.MATCH

        view.isError = (status) ->
          return status is STATUS.ERROR

        view.isNoSet = (status) ->
          return status is STATUS.NOSET

        view.getColumnDataType = (id) ->
          view.structure.columns[id].data_type.type

        view.checkIfReadyToSave = () ->
          view.readyToSave = _isValid()

        view.tableChanged = () ->
          if !(view.selectedTable.table is null)
            if _tableCanBeUsed()
              view.showColumnMatcher = true
            else
              view.showColumnMatcher = false
              _showError("This table can not be used with this Filter Set. Not enough columns with all the necessary data types.")
            _updateColumnsForCloning()
          view.checkIfReadyToSave()

        $scope.$on 'cloneFilterSet' , (event) ->
          if _isFilterSetNameValid()
            columnMatcher = {}
            for sourceColumn in view.columnsForCloning
              columnMatcher[sourceColumn.id] = sourceColumn.column

            for filter in view.editedFilterSet.filters
              filter.left.column_id = columnMatcher[filter.left.column_id]

            data =
              table_id: view.selectedTable.table
              name: view.filterSetName
              is_deleted: false
              sequence: view.editedFilterSet.sequence
              filters: view.editedFilterSet.filters

            FilterSets.create(view.clientId, data).then(
                (response) ->
                  logger.log('Filters Page Usage', 'Save', 1, 'clone')
                  $scope.$emit('filterSetsChanged', view.filterSetName)
              ,
                (error) -> _showError(errorConstants.SERVER_ERROR_MESSAGE)
              )

        @$onInit = () ->
          view.columns.push column for id, column of view.structure.columns
          view.filterSetsNames.push filterSet.name for filterSet in view.filterSets
          view.filterSetName = "#{view.editedFilterSet.name} Copy"
          notification.clear('filterSetCloner')
          _getColumnsForCloning()

        view
    ]
    link: (scope, element, attributes, view) ->

      scope.$watch 'view.selectedTable.table', view.tableChanged, true
      scope.$watch 'view.columnsForCloning', view.checkIfReadyToSave, true
      scope.$watch 'view.filterSetName', view.checkIfReadyToSave, true
]
